import { atom } from "jotai";

import { BookingWizard } from "../../../types";
import { BookingWizardDataAtom } from "../../stores";

export const setNonPlayingHostOnRoundAtom = atom(
  null,
  (get, set, payload: { playerId: string }, isNonPlayingHost: boolean) => {
    const bookingWizardData = get(BookingWizardDataAtom);
    if (!bookingWizardData) {
      //@TODO: this is an error
      return;
    }

    const roundExists = bookingWizardData?.rounds.some(
      (round) => round.player.id === payload.playerId
    );
    if (!roundExists) return;

    if (bookingWizardData?.type === "GolfBooking") {
      const newBookingWizardData: BookingWizard.GolfBookingWizardData = {
        ...bookingWizardData,
        rounds: bookingWizardData.rounds.map((round) => ({
          ...round,
          player: {
            ...round.player,
            ...(round.player.clientType === "member" && {
              nonPlayingHost:
                round.player.id === payload.playerId
                  ? isNonPlayingHost
                  : round.player.nonPlayingHost,
            }),
          },
        })),
      };
      set(BookingWizardDataAtom, newBookingWizardData);
    } else if (bookingWizardData.type === "RequestBooking") {
      set(BookingWizardDataAtom, {
        ...bookingWizardData,
        rounds: bookingWizardData.rounds.map((round) =>
          round.player.clientType === "member" &&
          round.player.id === payload.playerId
            ? {
                ...round,
                player: { ...round.player, nonPlayingHost: isNonPlayingHost },
              }
            : round
        ),
      });
    } else if (bookingWizardData?.type === "DurationBooking") {
      const newBookingWizardData: BookingWizard.DurationBookingWizardData = {
        ...bookingWizardData,
        rounds: bookingWizardData.rounds.map((round) => ({
          ...round,
          player: {
            ...round.player,
            ...(round.player.clientType === "member" && {
              nonPlayingHost:
                round.player.id === payload.playerId
                  ? isNonPlayingHost
                  : round.player.nonPlayingHost,
            }),
          },
        })),
      };
      set(BookingWizardDataAtom, newBookingWizardData);
    }
  }
);
